import { useTranslation } from 'react-i18next';
import MantineGrid from '../../../UI/MantineGrid/ManiteGrig';
import {
  formatDateFromDB,
  formatDateFromDB2,
} from '../../../../../utils/FormatDate';
import MachineOrdersOptions from './MachineOrdersOptions';
import { icons } from '../../../../../shared/icons';

const MachineOrders = ({
  data,
  getEditData,
  handleOpenDeleteDialog,
  handlePosaljiZahtev,
}) => {
  // console.log('ZAHTEV ZA SERVIS FORMA', data);
  const { t, i18n } = useTranslation();
  const columns = [
    {
      field: 'idDok',
      headerName: '',
      enableColumnFilter: false,
      enableColumnOrdering: false,
      enableColumnActions: false,
      enableSorting: false,
      maxSize: 10,
      renderCell: (e) => (
        <MachineOrdersOptions
          getEditData={() => getEditData(e.cell.getValue())}
          handleOpenDeleteDialog={() =>
            handleOpenDeleteDialog(e.cell.getValue())
          }
          handlePosaljiZahtev={() => handlePosaljiZahtev(e.row.original)}
          poslato={e.row.original.poslato}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </MachineOrdersOptions>
      ),
    },
    {
      field: 'ceoBrDok',
      headerName: t('requestNumber'),
      size: 70,
    },
    {
      field: 'vremeKreiranja',
      headerName: t('date'),
      renderCell: (e) => {
        return formatDateFromDB(e.row.original.vremeKreiranja);
      },
      size: 100,
    },
    {
      field: 'poslato',
      headerName: t('labelSent'),
      renderCell: (e) => (
        <span
          style={{
            fontWeight: 'bold',
            color: e.row.original.poslato ? 'green' : 'red',
          }}
        >
          {e.row.original.poslato
            ? t('buttons.yes')?.toUpperCase()
            : t('buttons.no')?.toUpperCase()}
        </span>
      ),
      size: 150,
    },

    {
      field: 'status',
      headerName: t('requestStatus'),
      size: 130,
    },
    {
      field: 'naslov',
      headerName: t('title'),
      // size: 200,
    },
    {
      field: 'vrsteKvarova',
      headerName: t('typeOfFailure'),
      // size: 200,
    },
    {
      field: 'statusMasine',
      headerName: t('machineStatus'),
      size: 120,
    },
    {
      field: 'imeKorisnikaSlanjaZahteva',
      headerName: t('reportedBy'),
      size: 160,
    },
    {
      field: 'rokZavrsetka',
      headerName: t('rokZavrsetka'),
      renderCell: (cell) => {
        const d = new Date(cell.row.original.rokZavrsetka);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}.${month}.${year}`;
      },
      size: 100,
    },
  ];
  const columnsDetail = [
    {
      field: 'status',
      headerName: t('status'),
      // size: 300,
    },
    {
      field: 'orderType',
      headerName: t('orderType'),
      // size: 200,
    },
    {
      field: 'billingType',
      headerName: t('billingType'),
      // size: 200,
    },
    {
      field: 'title',
      headerName: t('title'),
      // size: 150,
    },
    {
      field: 'notificationDate',
      headerName: t('notificationDate'),
      // size: 150,
    },
  ];
  return (
    <div
      style={{
        marginTop: '10px',
        height: 'fit-content',
        width: '99%',
      }}
    >
      <MantineGrid
        // enableTableDetail
        columns={columns}
        data={data}
        columnsDetail={columnsDetail}
        enablePagination={false}
      />
      {/* <MuiGrid data={data} loading={loading} columns={columns} /> */}
    </div>
  );
};

export default MachineOrders;
